// Function to normalize string
export const normalizeString = (string) =>
  string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/-/g, " ")
    .toLowerCase();

// Function returning boolean: true if the string matches all the terms
export const stringMatchEveryTerms = (
  string,
  search_terms,
  separator = " "
) => {
  const searchString = normalizeString(string);
  const array = Array.isArray(search_terms)
    ? search_terms
    : search_terms.split(separator);
  return array.every((term) => searchString.match(normalizeString(term)));
};

// Function returning boolean: true if the string matches some of the terms
export const stringMatchSomeTerms = (string, search_terms, separator = " ") => {
  const searchString = normalizeString(string);
  const array = Array.isArray(search_terms)
    ? search_terms
    : search_terms.split(separator);
  return array.some((term) => searchString.match(normalizeString(term)));
};

// Function to normalize string without special characters
export const normalizeStringWithoutSC = (string) =>
  string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z ]/g, "")
    .replace(/-/g, " ")
    .toLowerCase();

// Function to convert some article fields (ex: title: ["text"] should be title: "text").
const getFields = (fieldsObj) => {
  if (fieldsObj) {
    return Object.entries(fieldsObj).reduce((acc, [key, value]) => {
      const isTextField = ["title", "summary", "text_content"].includes(key);
      return {
        ...acc,
        [key]: isTextField ? value[0] : value,
      };
    }, {});
  }
};

export const retrieveTranslatedData = (elasticArticleData) => {
  const originalLanguage = elasticArticleData?._source?.original_language;
  const returnedVersion = Object.keys(
    elasticArticleData?._source?.versions || {}
  )[0];

  // si la langue préférée est renseignée, que la langue originale existe
  // que la langue préférée est différente de langue originale et que la traduction existe
  const isArticleTranslated =
    !!originalLanguage &&
    !!returnedVersion &&
    returnedVersion !== "original" &&
    returnedVersion !== originalLanguage;

  // Get article content from returned version or (if no version returned) from "fields" fallback
  const articleContents =
    elasticArticleData?._source?.versions?.[returnedVersion] ||
    getFields(elasticArticleData?.fields);

  return {
    articleContents,
    isArticleTranslated,
    originalLanguage,
    returnedVersion,
  };
};
